import { AuthenticatedImage } from '@/components/features/authenticated-image'
import { imageDocumentSrc } from '@/lib/image-document'
import type { DocumentRendererProps } from '@/lib/document-renderer-registry'
import { testIds } from '@/lib/test-ids'

export function ImageDocumentViewer({ document }: DocumentRendererProps) {
  const src = imageDocumentSrc(document.id)
  const alt = document.title || 'Image'

  return (
    <div
      className="flex h-full min-h-0 flex-col"
      data-testid={testIds.imageDocument.viewer}
    >
      <div className="flex min-h-0 flex-1 items-center justify-center overflow-auto p-6">
        <AuthenticatedImage
          rawSrc={src}
          alt={alt}
          data-testid={testIds.imageDocument.image}
          className="max-h-[calc(100dvh-12rem)] w-auto max-w-full object-contain"
        />
      </div>
    </div>
  )
}
